import { vsSignupStorageKey } from '@/utils/vs-signup-policy'

export const sessionStorageMixin = {
  methods: {
    saveToStorage (key, value) {
      sessionStorage.setItem(vsSignupStorageKey(this.$route, key), JSON.stringify(value))
    },
    getFromStorage (key) {
      return JSON.parse(sessionStorage.getItem(vsSignupStorageKey(this.$route, key)))
    },
    removeFromStorage (key) {
      return sessionStorage.removeItem(vsSignupStorageKey(this.$route, key))
    }
  }
}
